import http from 'axios'
import qs from 'qs'

let cancel ,promiseArr = {}  //记录请求方法
let CancelToken = http.CancelToken	//请求拦截
const debug = process.env.NODE_ENV !== 'production'
// http.defaults.baseURL = debug ? '本地测试请求路径' : '生产环境路径'
http.defaults.baseURL = debug ? '/api' : ''

http.defaults.timeout = 30 * 1000
//配置axios请求头.可能根据后台的接口需要改charset
http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

http.interceptors.request.use((config) => {
	// if(config.url != 'upm/resource/findMenu'){ //当前页不为首页时,页面刷新菜单列表消失;获取菜单方法可多次执行
	// 	//发起请求添加取消方法
	// 	config.cancelToken = new CancelToken(c => {
	//         cancel = c
	//    })
	// }
	// if(config.url.indexOf("login") == -1 && config.url.indexOf("token") == -1 && config.url.indexOf("validate") == -1 ){
	// 	config.headers['Authorization'] = localStorage.getItem('Authorization')
	// }
    if (config.method === 'post'&&config.headers['Content-Type'] != "application/json") {
    	config.data = qs.stringify(config.data)
    }

    //发起请求时，取消掉当前正在进行的相同请求
    if (promiseArr[config.url]) {
        promiseArr[config.url]('操作取消')
        promiseArr[config.url] = cancel
    } else {
        promiseArr[config.url] = cancel
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

http.interceptors.response.use((res) => {
    return res
}, (error) => {
    return Promise.reject(error)
})

export default http


// WEBPACK FOOTER //
// ./src/service/base.js